import { render, staticRenderFns } from "./studentScoreEntryComponent.vue?vue&type=template&id=96ce63b2&scoped=true&"
import script from "./studentScoreEntryComponent.vue?vue&type=script&lang=js&"
export * from "./studentScoreEntryComponent.vue?vue&type=script&lang=js&"
import style0 from "./studentScoreEntryComponent.vue?vue&type=style&index=0&id=96ce63b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce63b2",
  null
  
)

export default component.exports